import { useCallback } from 'react';
import { useRouter } from '@/i18n/routing';

const DEFAULT_REDIRECT_URL = '/create/img2video';

export const useRedirectTry = () => {
  const router = useRouter();

  const handleClickLogin = useCallback(
    (url = DEFAULT_REDIRECT_URL, _type = 'landing - default') => {
      router.push(url);
    },
    [router],
  );
  return handleClickLogin;
};
